import { ModalState } from './types'

const state = (): ModalState => ({
  current: null,
})

export default state
